import { Component, OnInit ,ChangeDetectorRef} from '@angular/core';
import { Editor, Toolbar } from 'ngx-editor';
import { FormControl, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { ToastrService } from 'ngx-toastr';
import { SocialMediaAccount } from 'src/app/Models/SocialMediaAccountResponse';

@Component({
  selector: 'app-create-post',
  templateUrl: './create-post.component.html',
  styleUrls: ['./create-post.component.css']
})
export class CreatePostComponent {
  postImage :string[]=[];
  day: string = this.getCurrentDay(); 
  selectedCollection: string = 'General';
  selectedChannels: string[] = ['Business'];
  choice1: string = '';
  choice2: string = '';
  isScheduled: boolean = false;
  isPost: boolean = true;
  isShortVideo: boolean = false;
  isStory: boolean = false;
  isThread: boolean = false;
  isPoll: boolean = false;
  mediaFiles: string[] = []; 
  editor: Editor = new Editor();
  SocialMediaAccountsData:SocialMediaAccount[]=[];
  ClientUserId: string = "";
  UserId:string="";
  BusinessInfoId: string = "";
  toolbar: Toolbar = [
    ['bold', 'italic', 'underline', 'text_color', 'background_color'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link'],
    ['align_left','align_center','align_right','align_justify',],
  ];
  // editorContent = new FormControl('');
  editorContent : string = "";
  getSafeValue(value: string | null): string {
    return (value === null || value === "undefined") ? "" : value;
  }
  scheduledDate: Date | null = null;
  selectedHour: number | null = null;
  selectedMinute: number | null = null;
  scheduledDateType : string = "";
  selectedHourType: string = "";
  selectedMinuteType: string = "";
  selectedAccount: string = "";
  getImagePath(accountType: string): string {
    switch (accountType) {
      case 'Threads':
        return './assets/social_channel/threads.svg';
      case 'Facebook':
        return './assets/social_channel/facebook.svg';
      case 'Instagram':
        return './assets/social_channel/insta.svg';
      case 'X (Twitter)':
        return './assets/social_channel/twitter.svg';
      case 'LinkedIn':
        return './assets/social_channel/linkedin.svg';
      // Add more cases for additional account types if needed
      default:
        return ''; // Fallback image if no match
    }
  }

  hours: number[] = Array.from({ length: 24 }, (_, i) => i);  // 0-23
  minutes: number[] = Array.from({ length: 60 }, (_, i) => i); // 0-59

  onSubmit() {
    this.scheduledDateType = this.scheduledDate == null || this.scheduledDate == undefined ? "" : this.datepipe.transform(this.scheduledDate, "MM/dd/yyyy") + "";
    this.selectedHourType = String(this.selectedHour);
    this.selectedMinuteType = String(this.selectedMinute);
  
    const formData = new FormData();
    
    // Add details object
    const details = {
      folderName: "ManagerCreatPost",
    };
  
    if (this.photoPreviews.length > 0) {
      const year = this.scheduledDate?.getFullYear();
      const month = this.scheduledDate?.getMonth();
      const date = this.scheduledDate?.getDate();

      // Add eventDetails
      const eventDetails = {
        BusinessInfoId: this.BusinessInfoId,
        UserId: this.ClientUserId,
        AccountId: this.selectedAccount,
        EventCaption: this.editorContent,
        ScheduledDate: new Date(Number(year), Number(month), Number(date), Number(this.selectedHour), Number(this.selectedMinute), 0)
      };
      formData.append('eventDetails', JSON.stringify(eventDetails));
  
      // Convert Base64 strings to Blob and append them to FormData
      this.photoPreviews.forEach((base64String, index) => {
        const blob = this.base64ToBlob(base64String);
        formData.append('files', blob, `image_${index}.png`); // Name each file
      });
      this.app.displayLoader(true);
      // Call the service
      this.service.managerCreatPost(formData).subscribe(
        (response: any) => {
          if (response.link) {
            this.postImage = [response.link]; // Store the link in postImage array
          }
          this.app.displayLoader(false);
          this.toastr.success('File uploaded successfully', 'Success');
        },
        (error) => {
          this.app.displayLoader(false);
          this.toastr.error('Error uploading file', 'Error');
          console.error('Error uploading file:', error);
        }
      );
    } else {
      this.toastr.error('Please fill in all required fields correctly.', 'Error');
      this.app.displayLoader(false);
      console.warn('No file or cropped image available for upload.');
    }
  }
  
 
  ngOnInit() {
    this.editor = new Editor();
    this.ClientUserId = this.getSafeValue(localStorage.getItem("ClientUserId"));
    // this.UserId = this.getSafeValue(localStorage.getItem("UserId"));
    this.BusinessInfoId = this.getSafeValue(localStorage.getItem("BusinessInfoId"));
    console.log(this.BusinessInfoId)
    console.log(this.ClientUserId)
    this.service.ListOfSocialMediaAccounts(this.ClientUserId,this.BusinessInfoId).subscribe(data => {
        this.SocialMediaAccountsData = data.SocialMediaAccounts;
    });
  }
  ngOnDestroy(): void {
    this.editor.destroy();
  }
  get isPreviewEmpty(): boolean {
    return !this.editorContent.trim() && this.photoPreviews.length === 0;
  }
  

  constructor(  public sanitizer: DomSanitizer , private cdRef: ChangeDetectorRef, public service:SharkifyAiSerivceService,public router: Router,public datepipe : DatePipe, public app: AppComponent,
    private toastr: ToastrService) {}
  photoPreviews: string[] = [];

  onFilesSelected(event: Event): void {
    const files = (event.target as HTMLInputElement).files;
  
    if (files && files.length) {
      this.photoPreviews = []; // Clear any existing previews
  
      Array.from(files).forEach(file => {
        const reader = new FileReader();
        
        reader.onload = () => {
          const base64String = reader.result as string; // Base64 encoded string
          this.photoPreviews.push(base64String); // Push Base64 string into the array
        };
  
        reader.readAsDataURL(file); // Read the file as a Base64 string
      });
    }
  }
  
  base64ToBlob(base64: string): Blob {
    const byteString = atob(base64.split(',')[1]); // Decode Base64 (removing `data:image/...` prefix)
    const mimeString = base64.split(',')[0].split(':')[1].split(';')[0]; // Extract MIME type
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
  
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }
  
    return new Blob([arrayBuffer], { type: mimeString });
  }
  
  getsafevalue(value : any){
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
  getCurrentDay(): string {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const today = new Date();
    return days[today.getDay()];
  }

  onCollectionChange(event: any): void {
    this.selectedCollection = event.target.value;
  }

  toggleChannel(channel: string): void {
    const index = this.selectedChannels.indexOf(channel);
    if (index > -1) {
      this.selectedChannels.splice(index, 1);
    } else {
      this.selectedChannels.push(channel);
    }
  }

  toggleSchedule(): void {
    this.isScheduled = !this.isScheduled;
  }

  onContentChange(event: any): void {
    // this.postContent = event.target.value;
  }

  addMedia(media: string): void {
    this.mediaFiles.push(media);
  }


  saveAsDraft(): void {
    
  }
  addToQueue(): void {
  }
  currentIndex = 0;


  prevSlide(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.photoPreviews.length - 1;
    }
  }

  nextSlide(): void {
    if (this.currentIndex < this.photoPreviews.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0;
    }
  }
  toPost(){
    this.isPost=true;
    this.isShortVideo=false;
    this.isStory=false;
    this.isThread=false;
    this.isPoll=false;
  }
  toShortVideo(){
    this.isShortVideo=true;
    this.isPost=false;
    this.isStory=false;
    this.isThread=false;
    this.isPoll=false;
  }
  toStory(){
    this.isStory=true;
    this.isPost=false;
    this.isShortVideo=false;
    this.isThread=false;
    this.isPoll=false;
  }
  toThread(){
    this.isThread=true;
    this.isPost=false;
    this.isShortVideo=false;
    this.isStory=false;
    this.isPoll=false;
  }
  toPoll(){
    this.isPoll=true;
    this.isPost=false;
    this.isShortVideo=false;
    this.isStory=false;
    this.isThread=false;
  }
  videoPreview: string | null = null;

  onVideoSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file) {
      const newVideoPreview = URL.createObjectURL(file);

    if (newVideoPreview !== this.videoPreview) {
      this.videoPreview = newVideoPreview; // Only set if it's different
    }
    this.cdRef.detectChanges();
    }
  }

}
